import { Box, CircularProgress, Grid } from "@mui/material";

export const Spinner = ({ msg }: { msg: string }) => {
  return (
    <Grid container spacing={2} fontFamily={"Montserrat"}>
      <Grid item xs={12} sm={12} md={12} lg={12} sx={{ marginTop: "5%" }}>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          height="100vh"
        >
          <CircularProgress />
          <br />
          {msg || "...Cargando"}
        </Box>
      </Grid>
    </Grid>
  );
};
